import { render, staticRenderFns } from "./openVideoClass.vue?vue&type=template&id=e1b0a10c"
import script from "./openVideoClass.vue?vue&type=script&lang=js"
export * from "./openVideoClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b0a10c')) {
      api.createRecord('e1b0a10c', component.options)
    } else {
      api.reload('e1b0a10c', component.options)
    }
    module.hot.accept("./openVideoClass.vue?vue&type=template&id=e1b0a10c", function () {
      api.rerender('e1b0a10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/video/openVideoClass.vue"
export default component.exports